const Paths = {
  Base: "/",
  Login: "/login",
  Logout: "/logout",
  Unauthorized: "/unauthorized",
  Validate: "/validate",
  Home: "/home",
};

export default Paths;